import { PaymentMethodUpdatePage } from '@/features/payment-method/pages/PaymentMethodUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/payment-method/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["payment_methods.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PaymentMethodUpdatePage,
})
